package org.moxultimate.topwithmox.productcrud.main

import androidx.compose.runtime.Immutable
import org.moxultimate.topwithmox.product.data.ProductContentResponse

/**
 * ProductCRUDState
 * Sealed state for create/update/delete operations in the product content CRUD flow.
 */
@Immutable
sealed class ProductCRUDState {
    data object Idle : ProductCRUDState()
    data object Loading : ProductCRUDState()
    data class Success(val message: String) : ProductCRUDState()
    data class Error(
        val message: String,
        val statusCode: Int = 0,
    ) : ProductCRUDState()
}

/**
 * ProductContentListState
 * Sealed state for the product content list shown in ProductCRUDPage.
 */
@Immutable
sealed class ProductContentListState {
    data object Loading : ProductContentListState()
    data class Success(
        val contents: List<ProductContentResponse>,
        val hasMore: Boolean = true,
    ) : ProductContentListState()
    data class Error(val message: String, val statusCode: Int = 0) : ProductContentListState()
}
